(ns hypnos.consumer.panels.consult.sleep-positions
  "The consult sleep positions step."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :sleep-positions :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :sleep-positions :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.sleep-positions/statement (:consult/service-type consult))]]])

(defn- sleep-positions-field
  [state]
  [:div.field.has-check.is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.sleep-positions/question))]]
   [:div.field-body
    [:div.field
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :sleep-position-side
         :name      :sleep-position-side
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/sleep-positions :value])
                               :sleep-position/side)
         :on-change (fn [e]
                      (let [sleep-positions (get-in @state [:consult :consult/sleep-positions :value])
                            old-value       (contains? sleep-positions :sleep-position/side)
                            new-value       (-> e .-target .-checked)
                            changed?        (or (get-in @state
                                                        [:consult :consult/sleep-positions :dirty?])
                                                (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 conj :sleep-position/side)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 disj :sleep-position/side))
                        (swap! state assoc-in
                               [:consult :consult/sleep-positions :dirty?]
                               changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/sleep-positions :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.sleep-position/side)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :sleep-position-back
         :name      :sleep-position-back
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/sleep-positions :value])
                               :sleep-position/back)
         :on-change (fn [e]
                      (let [sleep-positions (get-in @state [:consult :consult/sleep-positions :value])
                            old-value       (contains? sleep-positions :sleep-position/back)
                            new-value       (-> e .-target .-checked)
                            changed?        (or (get-in @state [:consult :consult/sleep-positions :dirty?])
                                                (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 conj :sleep-position/back)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 disj :sleep-position/back))
                        (swap! state assoc-in
                               [:consult :consult/sleep-positions :dirty?]
                               changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/sleep-positions :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.sleep-position/back)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :sleep-position-stomach
         :name      :sleep-position-stomach
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/sleep-positions :value])
                               :sleep-position/stomach)
         :on-change (fn [e]
                      (let [sleep-positions (get-in @state [:consult :consult/sleep-positions :value])
                            old-value       (contains? sleep-positions :sleep-position/stomach)
                            new-value       (-> e .-target .-checked)
                            changed?        (or (get-in @state [:consult :consult/sleep-positions :dirty?])
                                                (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 conj :sleep-position/stomach)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 disj :sleep-position/stomach))
                        (swap! state assoc-in
                               [:consult :consult/sleep-positions :dirty?]
                               changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/sleep-positions :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.sleep-position/stomach)]]]
     [:div.control
      [:label.b-checkbox.checkbox
       [:input
        {:id        :sleep-position-upright
         :name      :sleep-position-upright
         :type      :checkbox
         :checked   (contains? (get-in @state [:consult :consult/sleep-positions :value])
                               :sleep-position/upright)
         :on-change (fn [e]
                      (let [sleep-positions (get-in @state [:consult :consult/sleep-positions :value])
                            old-value       (contains? sleep-positions :sleep-position/upright)
                            new-value       (-> e .-target .-checked)
                            changed?        (or (get-in @state [:consult :consult/sleep-positions :dirty?])
                                                (not= new-value old-value))]
                        (if (and changed? new-value)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 conj :sleep-position/upright)
                          (swap! state update-in
                                 [:consult :consult/sleep-positions :value]
                                 disj :sleep-position/upright))
                        (swap! state assoc-in
                               [:consult :consult/sleep-positions :dirty?]
                               changed?)))
         :on-focus  (fn [_] (swap! state assoc-in
                                   [:consult :consult/sleep-positions :touched?]
                                   true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.sleep-position/upright)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The sleep positions step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; statement
     [statement @consult]
     ;; field
     [sleep-positions-field state]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
